/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Name_Form_Firstname_Placeholder1Inputs */

const en_user_name_form_firstname_placeholder1 = /** @type {(inputs: User_Name_Form_Firstname_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. John`)
};

const de_user_name_form_firstname_placeholder1 = /** @type {(inputs: User_Name_Form_Firstname_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Max`)
};

/**
* | output |
* | --- |
* | "e.g. John" |
*
* @param {User_Name_Form_Firstname_Placeholder1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const user_name_form_firstname_placeholder1 = /** @type {((inputs?: User_Name_Form_Firstname_Placeholder1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Name_Form_Firstname_Placeholder1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_user_name_form_firstname_placeholder1(inputs)
	return en_user_name_form_firstname_placeholder1(inputs)
});
export { user_name_form_firstname_placeholder1 as "user_name_form_firstName_placeholder" }